import React from "react";
import {Layout} from "antd";
import AppHeader from "../../AppHeader/AppHeader";
import RunsPanel from "../../Anonymizer/RunsPanel";

const {Content} = Layout;

const Runs = () => (
    <Layout style={{minHeight: "100vh", backgroundColor: "var(--sc-ground)"}}>
        <AppHeader area="runs"/>
        <Content style={{padding: "24px"}}>
            <RunsPanel/>
        </Content>
    </Layout>
);

export default Runs;
